module.exports = __webpack_public_path__ + "img/Monte_Kope_57.229ebac9.jpg";